// Angular imports
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-search-notes-editor',
    templateUrl: './search-notes-editor.component.html',
    styleUrls: ['./search-notes-editor.component.scss']
})
export class SearchNotesEditorComponent {
    @Input() visible = false;
    @Input() previousNotes: any;
    @Input() taskId: string;
    @Output() onNoteSave = new EventEmitter<any>();
    @Output() onNotesEditorClose = new EventEmitter<boolean>();

    onNotesPopClose(): void {
        this.previousNotes = null;
        this.visible = false;
        this.onNotesEditorClose.emit(false);
    }

    onSaveNotes(event: any): void {
        this.onNoteSave.emit(event);
    }
}
